import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  MainContainer,
  HeaderSection,
  Title,
  Subtitle,
  TableContainer,
  SideContainer,
  PageContent,
  LoadingContainer,
  LoadingSpinner,
  EmptyMessage,
} from "./styles";
import {
  BackgroundPattern,
  ButtonRow,
  ButtonContainerLeft,
  ButtonContainerRight,
  StyledButton as AreasStyledButton,
} from "../ListAreas/styles";
import { useLocation, useNavigate, } from 'react-router-dom';
import { TableAlertTickets } from "./DynamicTable/TableAlertTickets";
import Sidebar from "../../sidebar";
import Projects from "../../projects";
import Users from "../../users";
import Profile from "../../profile";
import KanbanBoard from "../../kanban_board";
import Settings from "../../settings";
import Dashboard from "../../dashboard";
import ContasWilder from "../../projects_t_engineering/ContasWilder/ContasWilder";
import InternRegisterUser from '../../inter_register_user';
import UserIntern from "../../../pages/user_intern";
import { guardianAlertService } from "../../../services/guardianAlertService";
import { useFullscreenState } from "../../../utils/fullscreen";
import { goToGuardianHub } from "../../../utils/appNavigation";
import AlertCodeSearchBar from "./AlertCodeSearchBar";
import { canAccessAlertRequests } from "../../../utils/userRoles";

export const ViewAlerts = () => {
  const [alertTickets, setAlertTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const user = location?.state?.user;
  const app_status = useSelector((state) => state.app_status.status);
  const collapsed = useSelector((state) => state.sidebar);
  const currentUser = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { fullscreenActive, toggleFullscreen } = useFullscreenState();
  const showAlertRequests = canAccessAlertRequests(currentUser);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const alertTicketsRes = await guardianAlertService.getCompleteAlerts();
        setAlertTickets(Array.isArray(alertTicketsRes) ? alertTicketsRes : []);
        setError(null);
      } catch (err) {
        console.error("Fetch error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCancel = () => {
    goToGuardianHub(dispatch, navigate);
  };

  return (
    <MainContainer collapsed={collapsed}>
      <BackgroundPattern />
      <Sidebar />
      <SideContainer collapsed={collapsed}>
        {app_status === 'Projetos' ? <Projects /> :
          app_status === 'Usuários' ? <Users /> :
            app_status === 'Meu Perfil' ? <Profile /> :
              app_status === "Desenvolvimento" ? <KanbanBoard /> :
                app_status === "Configurações" ? <Settings /> :
                  app_status === "cad_new_user" ? <InternRegisterUser userType={location.state?.userType} /> :
                    app_status === "edit_user" ? <UserIntern user={user} /> :
                      app_status === "Dashboard" ? <Dashboard /> :
                        app_status === "Contas" ? <ContasWilder /> :

                          <PageContent>
                            <ButtonRow>
                              <ButtonContainerLeft>
                                <AreasStyledButton type="button" onClick={handleCancel}>
                                  Voltar
                                </AreasStyledButton>
                                <AreasStyledButton
                                  type="button"
                                  onClick={toggleFullscreen}
                                >
                                  {fullscreenActive ? "Retornar" : "Tela Cheia"}
                                </AreasStyledButton>
                              </ButtonContainerLeft>
                              <ButtonContainerRight>
                                {showAlertRequests ? (
                                  <AreasStyledButton
                                    type="button"
                                    onClick={() => navigate("/view_alert_request")}
                                  >
                                    <span style={{ marginRight: "8px" }}>🔔</span>
                                    Solicitações
                                  </AreasStyledButton>
                                ) : null}
                              </ButtonContainerRight>
                            </ButtonRow>

                            <HeaderSection>
                              <Title>Lista de alertas</Title>
                              <Subtitle>
                                Gerencie alertas e tickets do sistema de monitoramento.
                              </Subtitle>
                            </HeaderSection>

                            <AlertCodeSearchBar />

                            {loading ? (
                              <LoadingContainer>
                                <LoadingSpinner />
                              </LoadingContainer>
                            ) : error ? (
                              <EmptyMessage $error>
                                Não foi possível carregar os dados. Tente novamente em instantes.
                              </EmptyMessage>
                            ) : alertTickets.length > 0 ? (
                              <TableContainer>
                                <TableAlertTickets alertTickets={alertTickets} />
                              </TableContainer>
                            ) : (
                              <EmptyMessage>
                                Não há chamados e alertas integrados para exibir no momento.
                              </EmptyMessage>
                            )}
                          </PageContent>
        }
      </SideContainer>
    </MainContainer>
  );
};
